import * as actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  // states and countries
  states: [],
  countries: [],

  // geocoding
  addresses: [],
  geocodingAddresses: [],
  addressList: [],
  expectedLocations: {}
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.FETCH_STATES_AND_COUNTRIES.SUCCESS: {
      const { states, countries } = action.payload;
      return {
        ...state,
        states,
        countries,
      };
    }
    case actionTypes.SAVE_OR_UPDATE_LOCATION.SUCCESS:
    case actionTypes.SAVE_OR_UPDATE_EXPECTED_LOCATION.SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case actionTypes.GET_LOCATION_LIST.SUCCESS:
    case actionTypes.DELETE_LOCATION.SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case actionTypes.GET_EXPECTED_LOCATION_LIST.SUCCESS:
    case actionTypes.DELETE_EXP_LOCATION.SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case actionTypes.FETCH_GEOCODING_ADDRESSES.SUCCESS:
    case actionTypes.SAVE_GEOCODING_ADDRESS.SUCCESS:
    case actionTypes.CHECKLOCATIONNAME.SUCCESS:
    case actionTypes.EDIT_LOCATION:
    case actionTypes.VERIFY_LOCATION:
      return {
        ...state,
        ...action.payload,
      };
    case actionTypes.DELETE_SUMMARY_ITEM:
      return {
        ...state,
        geocodingAddresses: state.geocodingAddresses.map(address => ({
          ...address,
          active: false,
        })),
      };
    case actionTypes.SIDEBAR_TO_MAP_STATE:
      return {
        connectState: true
      };
    default:
      return state;
  }
};
